
export default {
  // login error
  ERROR_LOGIN_ID_NULL: 1000, // 아이디 입력안함
  ERROR_LOGIN_PASSWORD_NULL: 1001, // 비밀번호 입력안함
  ERROR_LOGIN_INVALID_CREDENTIALS: 1002, // 아이디 혹은 비밀번호가 잘못 됨
  ERROR_LOGIN_INVALID_RESET_CODE: 1003, // 비밀번호 찾기 코드가 잘못 됨
  ERROR_LOGIN_INVALID_RECAPTCHA: 1004, // reCaptcha 필요함


  // board id
  BOARD_ID_NOTICE: 1, // 공지사항
  BOARD_ID_APPROVAL: 2, // 결재문서


  // alert message
  ALERT_MSG_UNDEFINED: '유저정보를 찾을수 없습니다.',
  ALERT_MSG_NOT_CONPETENCE: '권한이 없습니다.',

  ALERT_MSG_UNAUTHORIZED: '일치하는 계정이 존재하지 않습니다.',
  ALERT_MSG_DEFAULT_ERROR: '오류가 발생하였습니다. 관리자에게 문의해주세요.',


  getErrorCode (err) {
    const data = err.response.data
    const status = err.response.status

    if (status === 455) {
      return this.ERROR_LOGIN_INVALID_RECAPTCHA
    }

    if (data.error) {
      if (data.error === 'invalid_credentials')         return this.ERROR_LOGIN_INVALID_CREDENTIALS
      if (data.error === 'invalid_reset_password_code') return this.ERROR_LOGIN_INVALID_RESET_CODE

    } else if (data.errors) {

      if (data.errors.login)                            return this.ERROR_LOGIN_ID_NULL
      if (data.errors.password)                         return this.ERROR_LOGIN_PASSWORD_NULL
      if (data.errors.reset_password_code)              return this.ERROR_LOGIN_INVALID_RESET_CODE

    }

    return -1
  },
}
/**
 * https://docs.google.com/spreadsheets/d/1w-xCvJrkvv9u2QsfsThd1hqpscA3DYgOK8Hxtdfmz44/edit?gid=1154984626#gid=1154984626
 *
 * 시설·장비 유지관리
 * 청사 등 시설경비
 * 도로 유지·보수관리
 * 청소·폐기물수거 등 환경미화
 * 공원·녹지 유지관리
 * 산림조사 및 산림보호
 * 조리실무 및 급식실 운영
 * 실험·연구보조
 * 관공선 운영·관리
 * 온실·포장 등에서 농작업
 * 동물사육·가축방역 등 동물관리
 * 수산생물 양식·관리
 */
export const 현업업무 = ['시설·장비 유지관리', '청사 등 시설경비', '도로 유지·보수관리', '청소·폐기물수거 등 환경미화', '공원·녹지 유지관리', '산림조사 및 산림보호', '조리실무 및 급식실 운영', '실험·연구보조', '관공선 운영·관리', '온실·포장 등에서 농작업', '동물사육·가축방역 등 동물관리', '수산생물 양식·관리'];

/**
 * https://docs.google.com/spreadsheets/d/1w-xCvJrkvv9u2QsfsThd1hqpscA3DYgOK8Hxtdfmz44/edit?gid=1154984626#gid=1154984626
 *
 * **안전분야:**
 * 추락(사람이 떨어짐)
 * 낙하(물건이 떨어짐)
 * 전도(사람·물건의 넘어짐, 미끄러짐)
 * 비래(날아오는 물체에 맞음)
 * 붕괴(건물·물체의 무너짐)
 * 협착(깔리거나 끼임)
 * 충돌(부딪힘)
 * 절단, 베임, 찔림
 * 감전/누전
 * 화재/폭발
 *
 * **보건분야:**
 * 흡입/중독
 * 감염
 * 동식물 상해
 * 온열/한랭질환
 * 근골격계 질환
 * 뇌심혈관계 질환
 * 호흡기 질환
 * 피부질환
 * 동상/화상
 * 난청
 * 기타
 * @type {{}}
 */
export const 예상재해형태 = {
  안전분야: ['추락(사람이 떨어짐)', '낙하(물건이 떨어짐)', '전도(사람·물건의 넘어짐, 미끄러짐)', '비래(날아오는 물체에 맞음)', '붕괴(건물·물체의 무너짐)', '협착(깔리거나 끼임)', '충돌(부딪힘)', '절단, 베임, 찔림', '감전/누전', '화재/폭발'],
  보건분야: ['흡입/중독', '감염', '동식물 상해', '온열/한랭질환', '근골격계 질환', '뇌심혈관계 질환', '호흡기 질환', '피부질환', '동상/화상', '난청', '기타'],
}
